import React from 'react';
import './MainScreenHeader.scss';

interface MainScreenHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const MainScreenHeader: React.FC<MainScreenHeaderProps> = ({ title, subtitle, children }) => (
  <div className="main-screen-header">
    <div className="main-header-accent" aria-hidden="true" />
    <div className="main-header-content">
      <h2 className="main-header-title">{title}</h2>
      {subtitle && <p className="main-header-subtitle">{subtitle}</p>}
    </div>
    {children && <div className="main-header-actions">{children}</div>}
  </div>
);

export default MainScreenHeader;
